<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>供給停止作業割当画面</h1>

<!-- 検索条件コンポーネント -->
<form [formGroup]="searchReqForm">
    <div *ngIf="workTntshList && cmpnyAreaInit">
        <app-sgke320d-condition [workTntshList]="workTntshList" [cmpnyAreaList]="cmpnyAreaList"
            [cmpnyAreaInit]="cmpnyAreaInit" (onClickSearchEvent)="onClickSearch()" (onClickClearEvent)="onClickClear()">
        </app-sgke320d-condition>
    </div>
</form>
<div *ngIf="searchresultList.length > 0">
    <!-- 検索結果コンポーネント -->
    <app-sgke320d-result [workTntshList]="workTntshList" [searchresultList]="searchresultList"
        [searchresultHyojiInfo]="searchresultHyojiInfo" (onClickRegistEvent)="onClickRegist($event)">
    </app-sgke320d-result>
</div>